"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBorder = void 0;
var styled_components_1 = require("styled-components");
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var borderHelper = function (side) {
    switch (side) {
        case "top":
        case "right":
        case "bottom":
        case "left":
            return "border-" + escapeCss_1.default(side);
        case "all":
            return "border";
        default:
            return null;
    }
};
var setBorder = function (side, color, size) {
    if (size === void 0) { size = "1px"; }
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ": ", " solid ", ";\n"], ["\n  ", ": ", " solid ", ";\n"])), borderHelper(side), escapeCss_1.default(size), escapeCss_1.default(color));
};
exports.setBorder = setBorder;
var templateObject_1;
//# sourceMappingURL=border.js.map